<template>
  <div class="mt-2 text-right">
    <slot />
    <b-button v-if="!ocultarCancelar" type="button" class="ml-2" variant="secondary" @click="confirmarCancelacion">
      Cancelar
    </b-button>
    <b-button class="ml-2" type="submit" variant="primary"> Aceptar </b-button>
  </div>
</template>

<script>
export default {
  props: {
    urlCancelar: {
      type: String,
      default: "",
    },
    ocultarCancelar: {
      type: Boolean,
      default: false,
    },
    confirmar: {
      type: Boolean,
      default: false,
    },
    textoConfirmacion: {
      type: String,
      default: "",
    },
  },
  methods: {
    async confirmarCancelacion() {
      if (this.confirmar) {
        const t = this.textoConfirmacion || "¿Está seguro?";
        const ok = await this.$bvModal.msgBoxConfirm(t, { okTitle: "Aceptar", cancelTitle: "Cancelar" });
        if (!ok) {
          return;
        }
      }

      this.cancelar();
    },
    cancelar() {
      const event = new Event("botonera-edicion:cancelar");
      this.$emit("cancelar", event);

      if (event.defaultPrevented) {
        return;
      }

      if (this.urlCancelar) {
        this.$router.push(this.urlCancelar);
      } else {
        this.$emit("cancel");
      }
    },
  },
};
</script>
